import PhotosSection from "./PhotosSection";

export default PhotosSection;